import { Injectable } from "@angular/core";
import { ContentType } from "../../../app/core/shared/contentTypes";
import { CoreCOMService } from "../../../app/core/services/com.service";
import { CircularInjectionHelper } from "../../../app/core/services/circularInjectionHelper";
import { IObjectObserver } from "../../../app/core/services/IObjectObserver";
import { ObjectObserverFactory } from "../../../app/core/services/objectObserverFactory";
import { SOTObjectObserverData } from "../../core/services/objectObserver.service";
import { SOTStyleDataModel } from "../models";
import { Subscription } from "rxjs";
import { LocalKeys, StorageHive } from "../../core/services/valueStorage.service";
import * as $ from "jquery"

/** Sytle */

/** Verwaltet die Variable Custom Styles */
@Injectable()
export class SOTStyleService {

  private _sotStyleObsServ: IObjectObserver<SOTStyleDataModel>;
  private _styleChangedSubscription: Subscription;
  private _valueStorageChangedSubscription: Subscription;

  constructor(private _coreCOMService: CoreCOMService,
    private _circularInjectionHelper: CircularInjectionHelper) {
    const me = this;

    me._valueStorageChangedSubscription = me._coreCOMService.environment.valueStorage.ObserveChanges.subscribe(async (hiveAndKeys) => {
      if (hiveAndKeys.some((entry) => entry.hive == StorageHive.Local && entry.key == LocalKeys.sotLocation)) {
        await me.useSOTStyle();
      }
    });
    me.useSOTStyle();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._styleChangedSubscription) {
      me._styleChangedSubscription.unsubscribe();
    }
    if (me._valueStorageChangedSubscription) {
      me._valueStorageChangedSubscription.unsubscribe();
    }
  }

  /** use the style, if need */
  private async useSOTStyle(): Promise<void> {
    const me = this;
    const location = await me._coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.sotLocation);
    if (location) {
      // is new location other then momently used
      if (location != await me.getCurrentLanguageLocation()) {
        const data = new SOTObjectObserverData(location);
        // produkte seperat laden (um selbe bilder nicht doppelt und Producte ohne Bilder nicht zu laden)
        me._sotStyleObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<SOTStyleDataModel>(ContentType.SOTStyle, me._circularInjectionHelper, data);
        if (me._styleChangedSubscription) {
          me._styleChangedSubscription.unsubscribe();
          me._styleChangedSubscription = null;
        }
        me._styleChangedSubscription = me._sotStyleObsServ.ObserveChanges.subscribe(() => {
          me.writeSOTStyle();
        });
        me.writeSOTStyle();
      } else {
        // do nothing, the binding is correct
      }
    } else {
      // location unbekannt = keine sprach observer
      if (me._sotStyleObsServ) {
        me._sotStyleObsServ.Release();
        me._sotStyleObsServ = null;
        me.writeSOTStyle();
      }
    }
  }

  /** get location from current sotStyle, sonst null */
  private async getCurrentLanguageLocation(): Promise<number> {
    const me = this;
    // wenn sot languages da sind verwenden, sonst null
    if (me._sotStyleObsServ) {
      const ObserverData = await me._sotStyleObsServ.ObserverData;
      if (ObserverData) {
        return ObserverData["hyp_cus_nr"];
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  /** write "root:" style for SOT */
  private async writeSOTStyle(): Promise<void> {
    const me = this;
    let root_style = [];
    let extra_style = [];
    if (me._sotStyleObsServ) {
      const allStyles = await me._sotStyleObsServ.GetAllObjects();
      allStyles.forEach(styleModel => {
        if (styleModel.key == "[fonts-block]") {
          extra_style.push(styleModel.value); // fonts-block enthelt bereits fertiges css
        } else {
          root_style.push(styleModel.key + ":" + styleModel.value + ";");
        }
      });
    }
    $("style[name=global]").html(":root {\r\n" +
      root_style.join("\r\n") +
      "\r\n}\r\n" +
      extra_style.join("\r\n"));
  }

}
